module.exports = __webpack_public_path__ + "h5/img/line.05bf1c84.jpg";